import { render } from "./FleetOCIStorageSecret.vue?vue&type=template&id=44593fd6"
import script from "./FleetOCIStorageSecret.vue?vue&type=script&lang=js"
export * from "./FleetOCIStorageSecret.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__